<template>
  <div>
    <section class="xs-banner service-banner-2 contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-md-6 align-self-center">
            <div class="xs-banner-content">
              <div class="xs-banner-group">
                <h2 class="banner-title wow fadeInLeft" data-wow-duration="1s">SHARED HOSTING</h2>
                <p class="wow fadeInLeft" data-wow-duration="1.5s">Share processes and data securely on a need to know
                  basis without the need for reconciliation it combines a permissione.</p></div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 align-self-center">
            <div class="inner-welcome-image-group wow fadeIn">
              <img src="../assets/images/shared-hosting.png" data-parallax='{"y": 150}'
                   alt="hosting image">
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-1294" class="full-width-content post-1294 page type-page status-publish hentry">
          <div data-elementor-type="wp-page" data-elementor-id="1294"
               class="elementor elementor-1294 elementor-bc-flex-widget" data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-943498c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="943498c" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-59c73d5"
                        data-id="59c73d5" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-91df308"
                        data-id="91df308" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-0ef1b65 elementor-widget elementor-widget-xs-heading"
                              data-id="0ef1b65" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Shared Hosting</h3>
                                  <h2 class="heading-title">Why <span>SHARED HOSTING</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-c2b99bb"
                        data-id="c2b99bb" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-43f2e77 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="43f2e77" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-cca6155 animated-slow elementor-invisible"
                        data-id="cca6155" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-046974f elementor-widget elementor-widget-xs-image-box"
                              data-id="046974f" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190" src="../assets/images/choose-us-1.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">99.9% Uptime Guarantee</h4>
                                  <p>Share processes and data secure
                                    lona need to know basis</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-cfcaaad animated-slow elementor-invisible"
                        data-id="cfcaaad" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-893ddb5 elementor-widget elementor-widget-xs-image-box"
                              data-id="893ddb5" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190" src="../assets/images/choose-us-2.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Safe and Secured</h4>
                                  <p>Our team assured your web site is always safe and secure</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-cd655fe animated-slow elementor-invisible"
                        data-id="cd655fe" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7023089 elementor-widget elementor-widget-xs-image-box"
                              data-id="7023089" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190" src="../assets/images/choose-us-3.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Our Dedicated Support</h4>
                                  <p>We finally found a host that truly understood the unique</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-4304065 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="4304065" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e8e7556"
                        data-id="e8e7556" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-c9dc89b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="c9dc89b" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-a535b88"
                                    data-id="a535b88" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-641c937"
                                    data-id="641c937" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-b969001 elementor-widget elementor-widget-xs-heading"
                                          data-id="b969001" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">Pricing Plans</h3>
                                              <h2 class="heading-title">SELECT <span>BEST PLAN</span></h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-a492a66"
                                    data-id="a492a66" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <div
                              class="elementor-element elementor-element-851e2e3 elementor-widget elementor-widget-xs-pricing-table"
                              data-id="851e2e3" data-element_type="widget" data-widget_type="xs-pricing-table.default">
                              <div class="elementor-widget-container">
                                <div class="pricing-matrix pricing-expand wow fadeIn animated" data-height="1974px"
                                     data-min="967px"
                                     style="height: 967px; visibility: visible; animation-name: fadeIn;">
                                  <div class="row no-gutters">
                                    <div class="col-lg-3">
                                      <div class="pricing-matrix-item">
                                        <div class="d-lg-block d-md-none d-none">
                                          <div class="pricing-image border-bottom-0" style="height: 350px;">
                                            <img src="../assets/images/pricing_img-1.png" alt="pricing image"
                                                 draggable="false">
                                          </div>
                                          <div class="gap"></div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Visits per month </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Total Sites </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Hosting type </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Shared </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Bandwidth per month </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Imported SSL </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">24/7 phone support </span>
                                          </div>
                                          <div class="pricing-feature-item border-bottom-0">
                                            <span class="pricing-feature">Consultative onboarding </span>
                                          </div>
                                          <div class="gap"></div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Dev, Stage, Prod </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Transferable Sites </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Multisite ready </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">PHP 7 ready </span>
                                          </div>
                                          <div class="pricing-feature-item border-bottom-0">
                                            <span class="pricing-feature">LargeFS </span>
                                          </div>
                                          <div class="gap"></div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Global CDN </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Page Performance </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">SSL certificates </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">GeoTarget </span>
                                          </div>
                                          <div class="pricing-feature-item border-bottom-0">
                                            <span class="pricing-feature">Content Performance </span>
                                          </div>
                                          <div class="gap"></div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Imported SSL </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Readiness assessment </span>
                                          </div>
                                          <div class="pricing-feature-item border-bottom-0">
                                            <span class="pricing-feature">Success management </span>
                                          </div>
                                          <div class="gap"></div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Application Performance </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">High availability </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-9">
                                      <div class="pricing-matrix-slider owl-carousel owl-loaded">


                                        <div class="owl-stage-outer">
                                          <div class="owl-stage"
                                               style="transform: translate3d(0px, 0px, 0px); transition: all 0s ease 0s; width: 840px;">
                                            <div class="owl-item active" style="width: 280px;">
                                              <div class="pricing-matrix-item">
                                                <div class="pricing-feature-group border-bottom-0">
                                                  <h4 class="xs-title">Regular</h4>
                                                  <div class="pricing-body">
                                                    <p>The High performance cloud platform ever</p>
                                                    <div class="pricing-price">
                                                      <h2>
                                                        <sup>$</sup>
                                                        29 <span>/month</span>
                                                      </h2>
                                                    </div>
                                                    <a href="https://dash.episcloud.com" target="_self" class="btn btn-primary">Buy Now</a>
                                                  </div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Visits per month
                                                  </div>
                                                  <div class="pricing-feature">Up to 25000</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Total Sites</div>
                                                  <div class="pricing-feature">1</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Hosting type</div>
                                                  <div class="pricing-feature">Shared</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Shared</div>
                                                  <div class="pricing-feature">50 GB</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Bandwidth per
                                                    month
                                                  </div>
                                                  <div class="pricing-feature">256 GB</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Imported SSL</div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">24/7 phone support
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Consultative
                                                    onboarding
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Dev, Stage, Prod
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Transferable Sites
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Multisite ready
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">PHP 7 ready</div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">LargeFS</div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Global CDN</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Page Performance
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">SSL certificates
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">GeoTarget</div>
                                                  <div class="pricing-feature">Add On</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Content
                                                    Performance
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Imported SSL</div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Readiness
                                                    assessment
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Success management
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Application
                                                    Performance
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">High availability
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="owl-item active" style="width: 280px;">
                                              <div class="pricing-matrix-item">
                                                <div class="pricing-feature-group border-bottom-0">
                                                  <h4 class="xs-title">Standard</h4>
                                                  <div class="pricing-body">
                                                    <p>The High performance cloud platform ever</p>
                                                    <div class="pricing-price">
                                                      <h2>
                                                        <sup>$</sup>
                                                        39 <span>/month</span>
                                                      </h2>
                                                    </div>
                                                    <a href="https://dash.episcloud.com" target="_self" class="btn btn-primary">Buy Now</a>
                                                  </div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Visits per month
                                                  </div>
                                                  <div class="pricing-feature">Up to 50000</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Total Sites</div>
                                                  <div class="pricing-feature">3</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Hosting type</div>
                                                  <div class="pricing-feature">Shared</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Shared</div>
                                                  <div class="pricing-feature">100 GB</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Bandwidth per
                                                    month
                                                  </div>
                                                  <div class="pricing-feature">512 GB</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Imported SSL</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">24/7 phone support
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Consultative
                                                    onboarding
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Dev, Stage, Prod
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Transferable Sites
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Multisite ready
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">PHP 7 ready</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">LargeFS</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Global CDN</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Page Performance
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">SSL certificates
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">GeoTarget</div>
                                                  <div class="pricing-feature">Add On</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Content
                                                    Performance
                                                  </div>
                                                  <div class="pricing-feature">Add On</div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Imported SSL</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Readiness
                                                    assessment
                                                  </div>
                                                  <div class="pricing-feature">Limited</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Success management
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Application
                                                    Performance
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">High availability
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="owl-item active last-child" style="width: 280px;">
                                              <div class="pricing-matrix-item">
                                                <div class="pricing-feature-group border-bottom-0">
                                                  <h4 class="xs-title">Plus</h4>
                                                  <div class="pricing-body">
                                                    <p>The High performance cloud platform ever</p>
                                                    <div class="pricing-price">
                                                      <h2>
                                                        <sup>$</sup>
                                                        49 <span>/month</span>
                                                      </h2>
                                                    </div>
                                                    <a href="https://dash.episcloud.com" target="_self" class="btn btn-primary">Buy Now</a>
                                                  </div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Visits per month
                                                  </div>
                                                  <div class="pricing-feature">Unlimited</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Total Sites</div>
                                                  <div class="pricing-feature">5</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Hosting type</div>
                                                  <div class="pricing-feature">Shared</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Shared</div>
                                                  <div class="pricing-feature">500 GB</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Bandwidth per
                                                    month
                                                  </div>
                                                  <div class="pricing-feature">1 TB</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Imported SSL</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">24/7 phone support
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Consultative
                                                    onboarding
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Dev, Stage, Prod
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Transferable Sites
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Multisite ready
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">PHP 7 ready</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">LargeFS</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Global CDN</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Page Performance
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">SSL certificates
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">GeoTarget</div>
                                                  <div class="pricing-feature">Add On</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Content
                                                    Performance
                                                  </div>
                                                  <div class="pricing-feature">Add On</div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Imported SSL</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Readiness
                                                    assessment
                                                  </div>
                                                  <div class="pricing-feature">Unlimited</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Success management
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Application
                                                    Performance
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">High availability
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="owl-nav disabled">
                                          <div class="owl-prev disabled"><i class="icon icon-arrow-right"></i></div>
                                          <div class="owl-next disabled"><i class="icon icon-arrow-left"></i></div>
                                        </div>
                                        <div class="owl-dots disabled"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="content-collapse-wraper"><a href="#" class="btn btn-primary expand-btn">Load
                                  More <i class="icon icon-arrow_down"></i></a></div>
                                <input type="hidden" name="load_more_text" title="Load More" id="load_more_text"
                                       autocomplete="off" autocorrect="off">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-f269b39 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="f269b39" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0bc49a8"
                        data-id="0bc49a8" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-38b6bbc elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="38b6bbc" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d8cb099"
                                    data-id="d8cb099" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e3b84b5"
                                    data-id="e3b84b5" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-031c1bf elementor-widget elementor-widget-xs-heading"
                                          data-id="031c1bf" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">We Offer</h3>
                                              <h2 class="heading-title">FEATURES INCLUDED</h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d12eb8e"
                                    data-id="d12eb8e" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-170c00b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="170c00b" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-2a06e86"
                                    data-id="2a06e86" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-9b6daf0 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="9b6daf0" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="68"
                                                                                           src="../assets/images/included-feature-1.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">No Multi Tenancy</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-c465355 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="c465355" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="67"
                                                                                           src="../assets/images/included-feature-2.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-56b987a elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="56b987a" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="50" height="45"
                                                                                           src="../assets/images/included-feature-3.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> cPanel Hosting Control</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b3af8fd"
                                    data-id="b3af8fd" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-79ef854 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="79ef854" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="49" height="41"
                                                                                           src="../assets/images/included-feature-4.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title">PHP Selector</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-ab27e43 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="ab27e43" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="52" height="53"
                                                                                           src="../assets/images/included-feature-5.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> LiteSpeed Web Server</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-087da79 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                                          data-id="087da79" data-element_type="widget"
                                          data-widget_type="image-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image-box-wrapper">
                                              <figure class="elementor-image-box-img"><img width="47" height="55"
                                                                                           src="../assets/images/included-feature-6.png"
                                                                                           class="attachment-full size-full"
                                                                                           alt="" loading="lazy"
                                                                                           draggable="false"></figure>
                                              <div class="elementor-image-box-content"><h3
                                                class="elementor-image-box-title"> Patchman Kiler</h3>
                                                <p class="elementor-image-box-description">Share processes and data
                                                  secure lon a need to know basis with out the need for reconciliation
                                                  it combines.</p></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-352ccfd elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="352ccfd" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f5d3abd"
                        data-id="f5d3abd" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-4b8952d elementor-widget elementor-widget-xs-testimonial"
                              data-id="4b8952d" data-element_type="widget" data-widget_type="xs-testimonial.default">
                              <div class="elementor-widget-container">
                                <div class="xs-testimonial-slider owl-carousel owl-loaded owl-drag">

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transition: all 0s ease 0s; width: 3834px; transform: translate3d(-766px, 0px, 0px);">
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-2-55x55.png" alt="avatar-2"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-1-55x55.png" alt="avatar-1"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-4-55x55.jpg" alt="avatar-4"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active center" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-3-55x55.png" alt="avatar-3"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-2-55x55.png" alt="avatar-2"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-1-55x55.png" alt="avatar-1"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-4-55x55.jpg" alt="avatar-4"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-3-55x55.png" alt="avatar-3"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-2-55x55.png" alt="avatar-2"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img src="../assets/images/avatar-1-55x55.png" alt="avatar-1"
                                                     class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-42d9b0a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="42d9b0a" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6e01ddc"
                        data-id="6e01ddc" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-982e533 elementor-widget elementor-widget-xs-partner"
                              data-id="982e533" data-element_type="widget" data-widget_type="xs-partner.default">
                              <div class="elementor-widget-container">
                                <div class="xs-client-slider owl-carousel owl-loaded owl-drag">


                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transform: translate3d(-1120px, 0px, 0px); transition: all 0s ease 0s; width: 3360px;">
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-1.png"
                                                                          alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-2.png"
                                                                          alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-3.png"
                                                                          alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-4.png"
                                                                          alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-5.png"
                                                                          alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-1.png"
                                                                          alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-2.png"
                                                                          alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-3.png"
                                                                          alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-4.png"
                                                                          alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-5.png"
                                                                          alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-1.png"
                                                                          alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-2.png"
                                                                          alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-3.png"
                                                                          alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-4.png"
                                                                          alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img src="../assets/images/client-5.png"
                                                                          alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-e62c019 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="e62c019" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-4cef8eb"
                        data-id="4cef8eb" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-feb3173 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="feb3173" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138" src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-9b41803"
                        data-id="9b41803" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-201bcd0 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="201bcd0" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138" src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-6d8e020 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="6d8e020" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3854249"
                        data-id="3854249" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-b6992ed elementor-widget elementor-widget-spacer"
                              data-id="b6992ed" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'SharedHosting'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/SharedHosting.vue